import React from 'react';
import PropTypes from 'prop-types'
import '../assets/styles/components/Coupon.scss'
import { connect } from 'react-redux';
import { Row, Col, FillButton, TextInput, Text } from 'tailwind-react-ui';

const CouponComponent = ({id, coupon, type, onClick, ...rest}) =>{

    const textInput = React.useRef(null);

    var title;
    var sonar = false;
    const couponType = {
        send: 'send',
        share: 'share'
    }

    switch (type){
        case couponType.send:
            sonar = true,
            title = 'LO QUIERO';
            break;
        case couponType.share:
            title = 'COMPARTIR';
            break;
    }

    return(
        <Row {...rest}>
            <Col m={{b: 4}} className='w-full sm:w-full md:w-3/4 lg:w-4/6'>
                <TextInput 
                id={id}
                name={id}
                ref={textInput}
                defaultValue={coupon} 
                h={12} 
                rounded={'none'}
                className="quicksand-regular pointer-events-none rounded lg:rounded-l lg:rounded-r-none" 
                p={{l: 2, r: 2}}
                border={[true, 'white', 'dashed']}
                m={'auto'} 
                text={['white', '2xl']}
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}/>
            </Col>
            <Col m={{b: 4}} w={'1/2'} className='w-1/2 sm:w-1/2 md:w-2/4 lg:w-2/6'>
                <FillButton 
                className="quicksand-bold border-0 rounded lg:rounded-r lg:rounded-l-none overflow-hidden" 
                h={12} 
                rounded={'none'}
                m={'auto'} 
                w={'full'} 
                bg={'yellow'}
                style={{borderWidth: '0'}}
                text={['dark-purple', 'center', 'middle']}
                onClick={() => onClick()}>
                    {
                        sonar ? 
                        <>
                            <Text className="m-auto text-lg relative" style={{top: '2.5px'}}>{title}</Text>
                            <div className="sonar"/>
                            <div className="sonar sonar2"/>
                        </> :
                            <Text className="m-auto text-lg">{title}</Text>
                    }
                </FillButton>
            </Col>
        </Row>
    );
}

CouponComponent.propTypes = {
    id: PropTypes.string.isRequired,
    coupon: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func
}

const mapStateToProps = state => {
    return {
        coupon:state.coupon.code,
    };
};

export default connect(mapStateToProps, null)(CouponComponent);